// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex';
import store from './store'

// 引入elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import "./icons"; // icon

//引入全局样式
import "./assets/styles/base.css";
import "./assets/styles/common.css"

// Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(ElementUI);

// 导航守卫-路由前置钩子-在路由跳转之前触发
router.beforeEach((to, from, next) => {
  //用户登录之后，local storage里面有token
  let token = localStorage.getItem("token")
  if(token){
    next()
  }else{//没有token
    if(to.path == "/"){//如果是注册登录页，直接放行
      //如果访问的是登录页，直接放行
      next()
    }else{//访问的不是登录页，跳转到登录页
      next({path:"/"})
    }
  }
})

//路由后置钩子/面包屑
router.afterEach((to,from)=>{
  // console.log(to);
  // console.log(from);
  //store
  store.commit('SET_CRUMB',to.matched)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js